import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { HeroSection } from '@/components/landing/hero-section'
import { WhyChooseUs } from '@/components/landing/why-choose-us'
import { ServicesSection } from '@/components/landing/services-section'
import { BridalSpotlight } from '@/components/landing/bridal-spotlight'
import { InstagramSection } from '@/components/landing/instagram-section'
import { VisitSection } from '@/components/landing/visit-section'
import { AreasSection } from '@/components/landing/areas-section'
import { FaqSection } from '@/components/landing/faq-section'
import { CtaSection } from '@/components/landing/cta-section'

import {
    faqSchema,
    localBusinessSchema,
    schemaGraph,
    websiteSchema
} from '@/lib/structured-data'

import { homeFaqs } from '@/constants/content'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title="Women's beauty parlour in New Gupta Colony, Delhi"
                path='/'
                jsonLd={schemaGraph(localBusinessSchema(), websiteSchema(), faqSchema(homeFaqs))}
            />

            <HeroSection />
            <WhyChooseUs />
            <ServicesSection />
            <BridalSpotlight />
            <InstagramSection />
            <VisitSection />
            <AreasSection />
            <FaqSection />
            <CtaSection />
        </Layout>
    )
}

export default Home
